import React, { useEffect, useState } from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

const AddRemoveQtyButton = ({
  onIncreasePress = () => {},
  onReducePress = () => {},
  onTextChange = () => {},
  quantity = 0,
  textStyles = {},
}) => {
  const [enteredQty, setEnteredQty] = useState(Number(quantity));

  useEffect(() => {
    setEnteredQty(Number(quantity));
  }, [quantity]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    // Allow only numeric input
    if (/^\d*$/.test(value)) {
      onTextChange(value);
    }
  };

  return (
    <Box
      sx={{
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'White',
        border: '1px solid orange',
        padding: '0.2rem',
        borderRadius: '0.5rem',
      }}
    >
      <IconButton
        onClick={() => {
          onReducePress();
        }}
      >
        <Remove
          sx={{
            color: 'orange',
            fontSize: '1rem',
          }}
        />
      </IconButton>

      <TextField
        value={enteredQty}
        onChange={handleInputChange}
        sx={{
          p: 0,
          width: '2rem',
          border: 'none',
          color: 'orange',
          '& .MuiInputBase-input': {
            color: 'orange',
            paddingBottom: '0px',
          },
        }}
        InputProps={{
          disableUnderline: true,
        }}
        inputProps={{
          style: { textAlign: 'center', ...textStyles },
          disableUnderline: true,
        }}
        variant='standard'
        size='small'
      />

      <IconButton
        onClick={() => {
          onIncreasePress();
        }}
      >
        <Add
          sx={{
            color: 'orange',
            fontSize: '1rem',
          }}
        />
      </IconButton>
    </Box>
  );
};

export default AddRemoveQtyButton;
